module.exports = __webpack_public_path__ + "static/usecase_exchange2_right_bg@2x-2672afa192bab4706c747ee99d53f03e.png";